<template>
  <component
    :is="shapeComponent"
    :element="element"
  />
</template>

<script setup>
  import {
    SurfaceEditorElementShapeRect,
    SurfaceEditorElementShapeCircle
  } from '#components';

  const props = defineProps({
    element: Object,
    surface: Object
  });

  const content = computed(() => props.element.content);

  const shapeComponent = computed(() => {
    switch (content.value.shape_type) {
      case SURFACE_EDITOR_SHAPES.circle:
        return SurfaceEditorElementShapeCircle;
      case SURFACE_EDITOR_SHAPES.rectangle:
      default:
        return SurfaceEditorElementShapeRect;
    }
  });


</script>
